// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uf9idBGP_TACyp_zmPtR{flex-direction:column;padding:31.5px 31.5px 31.5px 31px;display:flex}.uf9idBGP_TACyp_zmPtR:not(:last-child){border-right:1px solid var(--border-neutral-default)}.opgcNcIoh3YtEx5VRmmI{margin-bottom:24px}.FQKYE7SlXeUjohAocnxB{margin-bottom:8px}.s29NfAzmNvMVF5yfCumP{color:var(--content-primary-secondary)}.AzfiDPhnaX47VTFsuaxt{flex-direction:column;gap:16px;padding:40px 0;display:flex}.RZ68kBILw0HD3Krtf5Yj{color:var(--content-primary-secondary)}.NKHUX33njsZZvDH12JYS{align-items:center;height:40px;display:flex}.EFTsFtXNDJ4rYqRi_kHA{background:var(--background-primary-inverted-primary);align-items:center;height:40px;display:flex}.wtDvz05_Kcc3M2usy0Za{flex-direction:column;display:flex}.fEFcdWfD1U0xANP9umfg{align-items:center;display:flex}.fEFcdWfD1U0xANP9umfg:not(:last-child){margin-bottom:12px}.ZhBJAggVTYKOUsljuNxE{margin-bottom:20px}.jI7XEi9e0zQbE867EQas{margin:0 4px 0 8px}.ewAuHZv5WpUWS4cscpKl{padding:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"planContainer": `uf9idBGP_TACyp_zmPtR`,
	"planIcon": `opgcNcIoh3YtEx5VRmmI`,
	"planTitle": `FQKYE7SlXeUjohAocnxB`,
	"planDescription": `s29NfAzmNvMVF5yfCumP`,
	"infoContainer": `AzfiDPhnaX47VTFsuaxt`,
	"infoContainer__suffix": `RZ68kBILw0HD3Krtf5Yj`,
	"infoContainerSuffix": `RZ68kBILw0HD3Krtf5Yj`,
	"selectPlan": `NKHUX33njsZZvDH12JYS`,
	"customCredits": `EFTsFtXNDJ4rYqRi_kHA`,
	"includesData": `wtDvz05_Kcc3M2usy0Za`,
	"includesDataLine": `fEFcdWfD1U0xANP9umfg`,
	"includesDataTitle": `ZhBJAggVTYKOUsljuNxE`,
	"includesDataLineText": `jI7XEi9e0zQbE867EQas`,
	"dropdownList": `ewAuHZv5WpUWS4cscpKl`
};
export default ___CSS_LOADER_EXPORT___;
